<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
        :collapse-action="true">
        <div class="vx-row">
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Name</label>
            <vs-input type="search" placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0" />
          </div>
        </div>
        <div class="mt-5 vx-row">
          <div class="w-full ml-auto vx-col">
            <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
              v-on:click="filters = {}">CLEAR</vs-button>
          </div>
        </div>
      </vx-card>
      <vx-card :title="'NIMBLE USER TYPES'" class="">
        <template slot="actions">
          <vs-button v-can="'view-user-type-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus"
            class="mr-4" color="primary" type="filled">create</vs-button>
        </template>
        <div id="customer-user-type-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="user_roles">
              <template slot="thead">
                <vs-th width="40%">Name</vs-th>
                <vs-th width="40%">Description</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    <vx-read-more :length="100" :text="data[indextr].description" />
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-user-type-setting'" v-if="data[indextr].name !== 'Accounts Payable'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3" size="small" color="warning"
                          type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-customer-user-type-pop-up ref="addNewCustomerUserTypePopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewCustomerUserTypePopUp from '@/components/popups/settings/customer-user-types/AddNewCustomerUserTypePopUp.vue';

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
const CustomerUserTypeRepository = RepositoryFactory.get('customer_user_type');

export default {
  name: "CustomerUserTypeSettings",
  data() {
    return {
      user_roles: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    AddNewCustomerUserTypePopUp
  },
  methods: {
    async refreshData() {
      await this.fetchCustomerUserType()
    },
    async fetchCustomerUserType() {
      await this.$vs.loading({
        container: '#customer-user-type-table',
        scale: 0.45
      })
      const { data } = await CustomerUserTypeRepository.getListOfUserType(this.page, this.filterQuery, this.perPage, this.sort)
      this.user_roles = data.data
      this.meta = data.meta
      this.$vs.loading.close('#customer-user-type-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.addNewCustomerUserTypePopUp.openPopup()
    },
    async onClickUpdate(id) {
      await this.$refs.addNewCustomerUserTypePopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await CustomerUserTypeRepository.deleteUserType(params[0])
        await this.fetchCustomerUserType()
        await this.showSuccessMessage('Customer user role deleted!');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    filterQueryUpdate() {
      this.fetchCustomerUserType()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchCustomerUserType()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchCustomerUserType()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted() {
    await this.fetchCustomerUserType()
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchCustomerUserType()
    },
    perPage() {
      this.fetchCustomerUserType()
    }
  }
}
</script>

<style scoped></style>
